import { Component } from '@theme/component';
class OrvenServices extends Component {
  requiredRefs = ['track', 'previous', 'next', 'counter'];
  #controller;
  #resize;
  connectedCallback() { super.connectedCallback(); this.#bind(); this.setAttribute('data-enhanced', ''); }
  updatedCallback() { super.updatedCallback(); this.#bind(); }
  disconnectedCallback() { this.#controller?.abort(); this.#resize?.disconnect(); super.disconnectedCallback(); }
  #bind() {
    this.#controller?.abort(); this.#resize?.disconnect(); this.#controller = new AbortController();
    this.refs.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal: this.#controller.signal });
    this.#resize = new ResizeObserver(() => this.updateControls()); this.#resize.observe(this.refs.track); this.updateControls();
  }
  previous() { this.#move(-1); }
  next() { this.#move(1); }
  handleKeydown(event) {
    if (event.target !== this.refs.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    this.#move((event.key === 'ArrowRight' ? 1 : -1) * (getComputedStyle(this.refs.track).direction === 'rtl' ? -1 : 1));
  }
  #move(direction) {
    const track = this.refs.track, first = track.firstElementChild;
    if (!first) return;
    const style = getComputedStyle(track), step = first.getBoundingClientRect().width + parseFloat(style.columnGap || '0');
    track.scrollBy({ left: direction * step * (style.direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  updateControls() {
    const { track, previous, next, counter } = this.refs, first = track.firstElementChild;
    if (!first) return;
    const position = Math.abs(track.scrollLeft), max = track.scrollWidth - track.clientWidth;
    const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0');
    const start = Math.round(position / step), visible = Math.max(1, Math.round(track.clientWidth / step));
    previous.disabled = position <= 2; next.disabled = position >= max - 2; this.toggleAttribute('data-scrollable', max > 2);
    counter.textContent = `${start + 1}–${Math.min(start + visible, track.children.length)} / ${track.children.length}`;
  }
}
if (!customElements.get('orven-services')) customElements.define('orven-services', OrvenServices);
